import React, { useEffect, useState } from 'react';
import { CallApiGet } from '../../apicalls/calls.js';
import { selectSorteosActivos, setActivos } from '../../slice/global';
import { useSelector, useDispatch } from 'react-redux';
import MisCapturasModal from '../modals/MisCapturasModal.jsx';

export default function Venta() {
    const [deuda, setDeuda] = useState(false);
    const [allowed, setAllowed] = useState(false);

    const AllSorteos = useSelector(selectSorteosActivos);
    const UsuarioS = JSON.parse(window.localStorage.getItem('usuario'));
    const dispatch = useDispatch();

    // const condition = () => {
    //     if(UsuarioS.user.tipo_usuario == 1 || !deuda) {
    //         return true;
    //     }
    //     return false;
    // }

    async function fetchData() {
        $("#backdrop").show();
        const Call = await CallApiGet('getSorteosActivos', { id_usuario: UsuarioS.user.id }, UsuarioS.access_token);
        setDeuda(Call.success.deuda);
        // console.log(UsuarioS.user.id)
        // console.log("Llamada de get", Call);
        dispatch(setActivos(Call.success.sorteos));
        $("#backdrop").hide();
        //dispatch(set)
    }

    const openMisCapturasModal = () => $('#mis-capturas').modal('show');

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        (() => {
            if (UsuarioS.user.tipo_usuario == 1 || !deuda) {
                setAllowed(true);
            }
            else {
                setAllowed(false);
            }
        })();
    }, [deuda]);

    return (
        <>
            <MisCapturasModal UsuarioS={UsuarioS} />
            <div className='container-fluid'>
                <div className="d-sm-flex align-items-center justify-content-between mb-4">
                    <h1 className="h3 mb-0 text-gray-800">Sorteos vigentes</h1>
                    <button className="btn btn-primary" onClick={openMisCapturasModal}>Mis Capturas</button>
                </div>
                {
                    !allowed &&
                    <div className="row">
                        <div className='col-sm-12 col-md-12 col-xl-12'>
                            <div className="alert alert-danger" style={{ fontSize: "16px" }} role="alert">
                                Usted tiene una deuda pendiente.
                            </div>
                        </div>
                    </div>
                }
                <div className='row'>
                    {AllSorteos.length == 0 && (
                        <div className='col-sm-12 col-md-12 col-xl-12'>
                            <div className="card mb-4 py-3 border-bottom-success">
                                <div className="card-body">
                                    No hay sorteos activos
                                </div>
                            </div>
                        </div>
                    )}

                    {AllSorteos && AllSorteos.map((item, key) => (
                        <div className="col-sm-12 col-md-4 col-lg-4" key={key}>
                            <div className="card shadow mb-4">
                                <div className="card-header py-3">
                                    <h6 className="m-0 font-weight-bold" style={{ color: "#E6453B" }}>{item.nombre}</h6>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-12 col-md-12 col-lg-6 text-center mb-4">
                                            <strong>Fecha Inicio</strong><br />
                                            {window.moment(item.fecha_inicio).locale('es-mx').format('L')}
                                        </div>
                                        <div className="col-sm-12 col-md-12 col-lg-6 text-center mb-4">
                                            <strong>Fecha Fin</strong><br />
                                            {window.moment(item.fecha_fin).locale('es-mx').format('L')}
                                        </div>
                                    </div>
                                    <div className="row">
                                        {
                                            allowed &&
                                            <a className="btn btn-primary btn-block" href={`${process.env.BASEURL}/Captura/Info/${item.id}`}>
                                                Capturar
                                            </a>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                </div>
            </div>
        </> 
    )
}
